import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AdministrativosSection.css';

export default function AdministrativosSection() {
  return (
    <div className="admin-section">
      <div className="admin-buttons">
        <h2 className="admin-title">Trámites Administrativos</h2>
        
        <div className="cards-tramites">
          
          {/* 1. Tasas y DREI (NUEVO - PRIMERO) */}
          <a className="card-tramite tasas-drei" href="https://progreso.miportal.ar/" target='_blank' rel="noreferrer" aria-label="Tasas y DREI">
            <div className="icono" style={{ color: '#3F51B5' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z" />
              </svg>
            </div>
            <h3>Tasas y DREI</h3>
            <hr/>
            <p><strong>Portal de autogestión de trámites comunales</strong></p>
          </a>

          {/* 2. Impuestos Inmobiliarios */}
          <a className="card-tramite api" href="https://www.santafe.gov.ar/e-in-boletas/index.php" target='_blank' rel="noreferrer" aria-label="Descarga impuestos API">
            <div className="icono" style={{ color: '#6d4c41' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0012 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75z" />
              </svg>
            </div>
            <h3>Descarga impuestos inmobiliario</h3>
            <hr/>
            <p><strong>Consultá y descargá tu boleta inmobiliaria</strong></p>
          </a>

          {/* 3. Patente Automotor */}
          <a className="card-tramite patente" href="https://www.santafe.gov.ar/e-pt-boletas/" target='_blank' rel="noreferrer" aria-label="Descargar patente">
            <div className="icono" style={{ color: '#1976D2' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 00-3.213-9.193 2.056 2.056 0 00-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 00-10.026 0 1.106 1.106 0 00-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
              </svg>
            </div>
            <h3>Descargar patente</h3>
            <hr />
            <p><strong>Consultá y descargá tu boleta de tu vehículo</strong></p>
          </a>

          {/* 4. Vencimientos API */}
          <a className="card-tramite vencimiento" href="https://www.santafe.gov.ar/index.php/web/content/download/283624/1467008/file/Calendario%20vencimientos%20impositivos%202026.pdf" target='_blank' rel="noreferrer" aria-label="Consultar vencimientos API">
            <div className="icono" style={{ color: '#8e3845' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5m-9-6h.008v.008H12v-.008zM12 15h.008v.008H12V15zm0 2.25h.008v.008H12v-.008zM9.75 15h.008v.008H9.75V15zm0 2.25h.008v.008H9.75v-.008zM7.5 15h.008v.008H7.5V15zm0 2.25h.008v.008H7.5v-.008zm6.75-4.5h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V15zm0 2.25h.008v.008h-.008v-.008zm2.25-4.5h.008v.008H16.5v-.008zm0 2.25h.008v.008H16.5V15z" />
              </svg>
            </div>
            <h3>Consultar vencimientos API</h3>
            <hr />
            <p><strong>Revisá tus fechas de vencimiento</strong></p>
          </a>

          {/* 5. Alta/Baja Patentes */}
          <Link
            to="/tramites/administrativos/a"
            className="card-tramite altaBaja"
            aria-label="Alta y baja de patentes"
          >
            <div className="icono" style={{ color: '#7b1fa2' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
              </svg>
            </div>
            <h3>Alta y baja de patentes</h3>
            <hr />
            <p><strong>Gestioná el alta o la baja de tu patente vehicular</strong></p>
          </Link>

          {/* 6. Licencia de Conducir */}
          <Link 
            to="/tramites/administrativos/licencia" 
            className="card-tramite licencia" 
            aria-label="Emisión de Licencia de conducir"
          >
            <div className="icono" style={{ color: '#f57c00' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-1.294-1.579 6.14 6.14 0 01-2.748.579 6.14 6.14 0 01-2.748-.579 6.721 6.721 0 01-1.294 1.579c.642.639 1.488 1.05 2.416 1.134.823.076 1.67-.043 2.416-.336.746.293 1.593.412 2.416.336.928-.084 1.774-.495 2.416-1.134z" />
              </svg>
            </div>
            <h3>Licencia de conducir</h3>
            <hr />
            <p><strong>Inicio / renovación / turnos</strong></p>
          </Link>

          {/* 7. Catastro */}
          <Link 
            to="/tramites/administrativos/catastro" 
            className="card-tramite catastro" 
            aria-label="Catastro"
          >
            <div className="icono" style={{ color: '#388E3C' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 6.75V15m6-6v8.25m.503 3.498l4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 00-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0z" />
              </svg>
            </div>
            <h3>Catastro</h3>
            <hr />
            <p><strong>Consultas de planos y obras privadas</strong></p>
          </Link>
          
          {/* 8. Oficina Virtual EPE */}
          <a className="card-tramite epe" href="https://epe.santafe.gov.ar/oficina-virtual/login" target='_blank' rel="noreferrer" aria-label="Oficina Virtual EPE">
            <div className="icono" style={{ color: '#FBC02D' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
              </svg>
            </div>
            <h3>Oficina Virtual EPE</h3>
            <hr />
            <p><strong>Accede a la oficina virtual de la EPE</strong></p>
          </a>

          {/* 9. Registro Vivienda */}
          <a className="card-tramite vivienda" href="https://www.santafe.gob.ar/rdav/" target='_blank' rel="noreferrer" aria-label="Registro Vivienda">
            <div className="icono" style={{ color: '#0097A7' }}>
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" width="52" height="52">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
              </svg>
            </div>
            <h3>Registro Vivienda</h3>
            <hr />
            <p><strong>Inscripción al registro digital de acceso a la vivienda</strong></p>
          </a>

          {/* 10. Juzgado de Faltas */}
          <div className="card-tramite juzgado">
            <div className="icono-emoji">⚖️</div>
            <h3>Juzgado de Faltas</h3>
            <hr />
            <p className="desc-juzgado">Atención de infracciones y consultas legales.</p>
            
            <div className="btns-contacto">
              {/* Botón de WhatsApp destacado */}
              <a href="https://wa.me/543497400307" target="_blank" rel="noreferrer" className="btn-whatsapp">
                <span className="btn-icon">💬</span> WhatsApp
              </a>

              {/* Botón de Email */}
              <a href="mailto:faltasprogreso@hotmail.com" className="btn-email">
                <span className="btn-icon">✉️</span> Enviar Mail
              </a>
              <p>faltasprogreso@hotmail.com</p>
              {/* Info de teléfono fijo */}
              <div className="info-fijo">
                <span className="fijo-icon">📞</span> 3497 488032 - Int. 34
              </div>
            </div>
          </div>
            
        </div>
      </div>
    </div>
  );
}